<ng-content></ng-content>
<div
    class="more-content-trigger"
    [ngClass]="{'more-content-trigger--show': showMoreContentTrigger}"
>
    <i class="icon">triggerdown</i>
    {{ 'configurator:scroll:more:options' | translate }}
</div>
